import isEmpty from '../node_modules/validator/es/lib/isEmpty.js';
import trim from '../node_modules/validator/es/lib/trim.js';

const isNotUndefined=stringVar=>stringVar!==undefined&&stringVar!=="undefined";const validateOrderNumber=(orderNumber,developmentMode)=>{const regx=developmentMode?/^[a-zA-Z]{5}_[\w\d]{8}$/:/^[a-zA-Z]{2}_[\w\d]{8}$/;return isNotUndefined(orderNumber)&&!isEmpty(trim(orderNumber))&&regx.test(trim(orderNumber))};

export { isNotUndefined, validateOrderNumber };
//# sourceMappingURL=Validation.js.map
